var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { View, Text, StyleSheet, Dimensions, TouchableOpacity } from 'react-native';
import { DRNUtil } from '@traveloka/district-util';
import DRNModal from '../../standard/Modal';
import DRNButton from '../../standard/Button/DRNButton';
import R from '../../core-res/R';
import PropTypes from 'prop-types';
import { withTheme } from '../../theme';
import CheckboxGroup from '../../standard/CheckboxGroup';
import RadioButtonGroup from '../../standard/RadioButtonGroup';
const { height: DEVICE_HEIGHT } = Dimensions.get('window');
const TYPES = {
    RADIO_BUTTON_TYPE: RadioButtonGroup,
    CHECKBOX_TYPE: CheckboxGroup,
};
class Tray extends Component {
    constructor(props) {
        super(props);
        this.isControlled = typeof this.props.isVisible !== 'undefined';
        this.handleOpenTray = () => {
            this.props.onTrayOpen();
            if (!this.isControlled) {
                this.setState({ isVisible: true });
            }
        };
        this.handleCloseTray = () => {
            if (!this.isControlled) {
                this.setState({ isVisible: false });
            }
        };
        this.handleClose = () => {
            this.handleCloseTray();
            this.props.onDismiss();
        };
        this.handlePrimaryButtonPress = () => {
            this.props.onPrimaryButtonPress();
            this.handleCloseTray();
        };
        this.handleSecondaryButtonPress = () => {
            this.props.onSecondaryButtonPress();
            this.handleCloseTray();
        };
        this.handleContentChange = value => {
            if (this.props.onContentChange) {
                console.warn('onContentChange is DEPRECATED. Change to onChange!');
            }
            const onChange = this.props.onChange || this.props.onContentChange;
            onChange(value);
        };
        this.state = {
            isVisible: false,
        };
    }
    render() {
        const _a = this.props, { isVisible, theme, title, subtitle, content, primaryButtonText, secondaryButtonText, primaryButtonStyle, secondaryButtonStyle, disabled, component, isSwipeEnabled } = _a, rest = __rest(_a, ["isVisible", "theme", "title", "subtitle", "content", "primaryButtonText", "secondaryButtonText", "primaryButtonStyle", "secondaryButtonStyle", "disabled", "component", "isSwipeEnabled"]);
        /**
         * @description: This validation to give control visibility from parent component
         */
        const visible = this.isControlled ? isVisible : this.state.isVisible;
        const ContentComponent = component || TYPES[content];
        if (disabled)
            return this.props.children;
        return (<View>
        {DRNUtil.isiOS() ? (<TouchableOpacity accessible={false} activeOpacity={1} onPress={this.handleOpenTray}>
            <View pointerEvents="box-only">{this.props.children}</View>
          </TouchableOpacity>) : (<View>
            {this.props.children}
            
            <TouchableOpacity style={StyleSheet.absoluteFill} onPress={this.handleOpenTray}/>
          </View>)}
        <DRNModal isVisible={visible} swipeDirection={isSwipeEnabled ? 'down' : null} onBackButtonPress={this.handleClose} onBackdropPress={this.handleClose} onSwipe={isSwipeEnabled ? this.handleClose : null} style={styles.modalContainer}>
          {isSwipeEnabled && <View style={[styles.trayMark, { backgroundColor: theme.darkSecondary }]}/>}
          <View style={[styles.container, { backgroundColor: theme.lightPrimary }]}>
            <View style={[styles.header, { borderBottomColor: theme.borderDivide }]}>
              <Text style={[styles.title, { color: theme.textPrimary }]}>{title}</Text>
              {!!subtitle && <Text style={[styles.subtitle, { color: theme.textSecondary }]}>{subtitle}</Text>}
            </View>
            <ContentComponent {...rest} onChange={this.handleContentChange}/>
            {(!!primaryButtonText || !!secondaryButtonText) && (<View style={[styles.footer, { borderTopColor: theme.borderDivide }]}>
                {!!secondaryButtonText && (<View style={styles.buttonContainerSecondary}>
                    <DRNButton smartKey={secondaryButtonText} variant={DRNButton.VARIANT.SECONDARY} buttonStyle={secondaryButtonStyle ? secondaryButtonStyle : null} onPress={this.handleSecondaryButtonPress}/>
                  </View>)}
                <View style={styles.buttonContainerPrimary}>
                  <DRNButton smartKey={primaryButtonText} variant={DRNButton.VARIANT.PRIMARY} buttonStyle={primaryButtonStyle ? primaryButtonStyle : null} onPress={this.handlePrimaryButtonPress}/>
                </View>
              </View>)}
          </View>
        </DRNModal>
      </View>);
    }
}
Tray.propTypes = {
    isVisible: PropTypes.bool,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ render: PropTypes.func.isRequired })]),
    content: PropTypes.oneOf(Object.keys(TYPES)),
    onContentChange: PropTypes.func,
    primaryButtonText: PropTypes.string,
    secondaryButtonText: PropTypes.string,
    primaryButtonStyle: PropTypes.shape({}),
    secondaryButtonStyle: PropTypes.shape({}),
    /**
     * Called when primary button is pressed
     */
    onPrimaryButtonPress: PropTypes.func,
    /**
     * Called when secondary button is pressed
     */
    onSecondaryButtonPress: PropTypes.func,
    /**
     * Called when Tray is dismissed from modal background
     */
    onDismiss: PropTypes.func,
    /**
     * Called when the Component onChange is called
     */
    onChange: PropTypes.func,
    /**
     * Called when children's TouchableOpacity is pressed
     */
    onTrayOpen: PropTypes.func,
    disabled: PropTypes.bool,
    theme: PropTypes.object,
    isSwipeEnabled: PropTypes.bool,
};
Tray.defaultProps = {
    onDismiss: () => { },
    onChange: () => { },
    onPrimaryButtonPress: () => { },
    onSecondaryButtonPress: () => { },
    onTrayOpen: () => { },
    disabled: false,
    isSwipeEnabled: true,
};
const modalContainerPlatformStyle = {};
if (DRNUtil.isWeb()) {
    // Web specific property to disable default gesture responder for vertical touch
    // This is to prevent unintended scrolling when trying to swipe the tray away.
    modalContainerPlatformStyle.touchAction = 'pan-x';
}
const styles = StyleSheet.create({
    container: {
        borderTopLeftRadius: R.border.radius.default,
        borderTopRightRadius: R.border.radius.default,
        maxHeight: (DEVICE_HEIGHT * 3) / 4,
    },
    header: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: R.spacing.xxs,
        borderBottomWidth: R.border.width.thin,
        minHeight: 44,
    },
    title: Object.assign({}, R.typography.title2, R.typography.weightMedium, { textAlign: 'center' }),
    subtitle: Object.assign({}, R.typography.uiTiny, { textAlign: 'center' }),
    footer: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        padding: R.spacing.m,
        paddingBottom: DRNUtil.getBottomInsetHeight() + R.spacing.m,
        borderTopWidth: R.border.width.thin,
    },
    buttonContainerPrimary: {
        flex: 1,
    },
    buttonContainerSecondary: {
        flex: 1,
        marginRight: R.spacing.m,
    },
    trayMark: {
        width: 24,
        height: 5,
        borderRadius: R.border.radius.default,
        margin: 5,
        alignSelf: 'center',
    },
    modalContainer: Object.assign({ margin: 0, justifyContent: 'flex-end' }, modalContainerPlatformStyle),
});
const ThemedTray = withTheme(Tray);
// Add static variable for each type
Object.keys(TYPES).forEach(value => {
    ThemedTray[value] = value;
});
export default ThemedTray;
